import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { Alignment, EmailInput, Icon, NIPInput, TextArea, TextInput } from 'tacho-ui';
import { AddClient, defaultAddClient } from '../../../core/domainModels/clients/AddClient';
import { ApplicationState } from '../../../state/ApplicationState';
import { addClientThunk, fetchClientsThunk } from '../../../state/clients/reducer';
import { DispatchType } from '../../../state/configureStore';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
interface AddClientModalProps {
    isOpen: boolean;
    onToggle: () => void;
}
export const AddClientModal = (props: AddClientModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [clientData, setClientData] = useState<AddClient>(defaultAddClient);
    const onSubmit = () => {
        dispatch(addClientThunk(clientData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchClientsThunk());
                    setClientData(defaultAddClient);
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const addClientPending = useSelector((state: ApplicationState) => state.clients.addClientPending);
    const addClientError = useSelector((state: ApplicationState) => state.clients.addClientError);

    return (
        <TachoModal
            size={'lg'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setClientData(defaultAddClient);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="clientAddClient" icon={Icon.User} />}
            submitLabelToTranslate="commonAdd"
            submitIcon={Icon.Add}
            isPending={addClientPending}
            errorToTranslate={addClientError}
            disableSubmitButton={
                !clientData.name ||
                !clientData.email ||
                !clientData.nip ||
                !clientData.country ||
                !clientData.zipCode ||
                !clientData.street ||
                !clientData.phoneNumber ||
                !clientData.houseNumber ||
                !clientData.city
            }
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientName' })}
                            value={clientData?.name}
                            onChange={value => setClientData({ ...clientData, name: value })}
                        />

                        <NIPInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientNip' })}
                            value={clientData?.nip}
                            onChange={value => setClientData({ ...clientData, nip: value })}
                        />

                        <EmailInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientEmail' })}
                            value={clientData?.email}
                            onChange={value => setClientData({ ...clientData, email: value })}
                        />

                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientPhoneNumber' })}
                            value={clientData?.phoneNumber}
                            onChange={value => setClientData({ ...clientData, phoneNumber: value })}
                        />

                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientCountry' })}
                            value={clientData?.country}
                            onChange={value => setClientData({ ...clientData, country: value })}
                        />
                    </Col>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientCity' })}
                            value={clientData?.city}
                            onChange={value => setClientData({ ...clientData, city: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientZipCode' })}
                            value={clientData?.zipCode}
                            onChange={value => setClientData({ ...clientData, zipCode: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientStreet' })}
                            value={clientData?.street}
                            onChange={value => setClientData({ ...clientData, street: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientHouseNumber' })}
                            value={clientData?.houseNumber}
                            onChange={value => setClientData({ ...clientData, houseNumber: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientApartmentNumber' })}
                            value={clientData?.apartamentNumber}
                            onChange={value => setClientData({ ...clientData, apartamentNumber: value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <TextArea
                        labelLength={-1}
                        label={formatMessage({ id: 'clientNotes' })}
                        align={Alignment.flexStart}
                        value={clientData.notes}
                        onChange={value => setClientData({ ...clientData, notes: value as string })}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
